import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "useritem" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "info-box",
  style: {"visibility":"visible"}
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "username" }
const _hoisted_7 = {
  class: "name",
  style: {"max-width":"128px"}
}
const _hoisted_8 = ["title"]

import { ref, watch } from "vue";
import { ElMessage } from "element-plus";
import axiosInstance from "@/utils/axiosInstance";

interface UserInfo {
  uuid: string;
  uname: string;
  ucompany: string;
  job_title: string;
  avatar_url: string;
  blog_address: string;
  description: string;
  isvip: number;
  userlevel: number;
  phone_verified: number;
  wechat_verified: number;
  weibo_verified: number;
  github_verified: number;
  weibo_nickname: string;
  weibo_html_url: string;
  github_nickname: string;
  github_html_url: string;
  followers: number;
  following: number;
  created_at: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'User-Item',
  props: {
  userId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;
//接口
const userInfo = ref<UserInfo>({
  uuid: "",
  uname: "",
  ucompany: "",
  job_title: "",
  avatar_url: "",
  blog_address: "",
  description: "",
  isvip: "",
  userlevel: "",
  phone_verified: "",
  wechat_verified: "",
  weibo_verified: "",
  github_verified: "",
  weibo_nickname: "",
  weibo_html_url: "",
  github_nickname: "",
  github_html_url: "",
  followers: "",
  following: "",
  created_at: "",
});
//获取用户简介
const fetchUserInfo = async () => {
  try {
    await axiosInstance
      .get("/api/HomeUser/profile_id", {
        params: { uuid: props.userId },
      })
      .then((res) => {
        var result = res.data;
        if (result.success) {
          userInfo.value = result.data;
        }
      });
  } catch (error) {
    ElMessage.error("获取用户信息失败");
  }
};

// 监听userId变化
watch(
  () => props.userId,
  (newVal) => {
    if (newVal) {
      fetchUserInfo();
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: `/user/${userInfo.value.uuid}`,
      target: "_blank"
    }, [
      _createElementVNode("img", {
        src: userInfo.value.avatar_url,
        class: "avatar"
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        href: `/user/${userInfo.value.uuid}`,
        target: "_blank"
      }, [
        _createElementVNode("span", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(userInfo.value.uname), 1)
        ]),
        _createElementVNode("div", {
          class: "position",
          title: userInfo.value.job_title + ' @' + userInfo.value.ucompany
        }, _toDisplayString(userInfo.value.job_title) + " @" + _toDisplayString(userInfo.value.ucompany), 9, _hoisted_8)
      ], 8, _hoisted_5)
    ])
  ]))
}
}

})